var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ['message-text-container']
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.TUITranslateService.t('AIDesk.并发限制')))])]);
}
var staticRenderFns = []

export { render, staticRenderFns }